<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">بيانات المدير</h3>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button"  data-toggle="modal" data-target="#myModal" (click)="getUser(admin)" class="btn btn-outline-secondary  dashed-button"  >تعديل البيانات </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table class="table no-border">

          <tbody>
          <ng-container *ngFor="let row of admins">
            <tr *ngIf="row.type==1">
              <th scope="row"  class="no-border">
                <div class="media align-items-center">
                  <a href="javascript:void(0)" class=" rounded-circle mr-3">
<!--                    <ngx-avatar name="{{row.name}}"></ngx-avatar>-->
                    <img [src]="row.profile_photo?row.profile_photo:'assets/images/profile-square.jpg'" class="avatar-person"/>

                  </a>
                  <div class="d-flex flex-column  ">
                    <div class="text-left">
                      <span class="mb-0 text-sm ">{{row.name}}</span><br>

                    </div>
                  </div>
                </div>
              </th>
              <td class="no-border ">
                <p class="py-3">{{row.email}}</p>
              </td>
              <td class="no-border">
                <p class="py-3">{{row.phone}}</p>
              </td>


            </tr>
          </ng-container>

          </tbody>
        </table>

      </div>
    </div>


    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">بيانات الجامعة</h3>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button" class="btn btn-outline-secondary  dashed-button"  data-toggle="modal" data-target="#uniModal"  >تعديل البيانات </button>
      </div>
    </div>

    <div class="row">
    <div class="col-md-3 text-left">
      <label>اسم الجامعة  </label><br>

      {{uniDataView['ar_name']}}
    </div>
        <div class="col-md-3 text-left">
          <label>العنوان  </label><br>

          {{uniDataView['address']}}
        </div>
        <div class="col-md-3 text-left">
          <label>البريد الإلكتروني </label><br>

          {{uniDataView['email']}}
        </div>
        <div class="col-md-3 text-left">
          <label>الهاتف </label><br>

          {{uniDataView['phone']}}
        </div>
      </div>
    <div class="row">
    <div class="col-md-3 text-left">
      <label>الموقع الإلكتروني  </label><br>

      {{uniDataView['website']}}
    </div>

    </div>




    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">إدارة المسؤولين</h3>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button" class="btn btn-outline-secondary  dashed-button" (click)="changeEditMode()" data-toggle="modal" data-target="#myModal"  >+ إضافة مسؤول </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table no-border">

          <tbody>
          <ng-container *ngFor="let row of admins">
            <tr *ngIf="row.type!=1" >
              <th scope="row"  class="no-border">
                <div class="media align-items-center">
                  <a href="javascript:void(0)" class=" rounded-circle mr-3">
<!--                    <ngx-avatar name="{{row.name}}"></ngx-avatar>-->
                    <img [src]="row.profile_photo?row.profile_photo:'assets/images/profile-square.jpg'" class="avatar-person"/>

                  </a>
                  <div class="d-flex flex-column  ">
                    <div class="text-left">
                      <span class="mb-0 text-sm ">{{row.name}}</span><br>

                    </div>
                    <div class="text-left">
                      <small class="text-right">{{row.type==2?'مسؤول الحركة':'محرر أخبار'}} </small>

                    </div>
                  </div>
                </div>
              </th>
              <td class="no-border mr-auto">
                <div class="d-flex flex-row-reverse" >

                  <div class=""  >
                    <i  data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(row)"  class="fa pointer border-red red  fa-trash circle"></i>

                  </div>
                  <div class="mr-2"  >
                    <i data-toggle="modal" data-target="#myModal" (click)="getUser(row._id)" class="fa pointer border-green green fa-pen circle"></i>

                  </div>

                </div>

              </td>



            </tr>
          </ng-container>

          </tbody>
        </table>

      </div>
    </div>

    </div>
</div>


<div class="modal fade" id="myModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{editMode?"تعديل":"إضافة"}} مسؤول </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <p>معلومات المسؤول</p>
        <form [formGroup]="data"  >
          <div class="row">
            <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12  text-center">
              <img (click)="openFile2()"  alt="User Pic" [src]="profileImg"  id="profile-image" class="radius-50 img-circle img-responsive">
              <input (change)="changeUserImage($event)" accept="image/*" type="file" id="file2"  style="display:none"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>الاسم الرباعي </label>

              <input type="text"  formControlName="name" placeholder="الاسم الرباعي" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>البريد الإلكتروني </label>

              <input type="text" [attr.disabled]="isAdmin" formControlName="email" placeholder="البريد الإلكتروني" class="form-control">
            </div>
            <div class="col-md-6">
              <label>رقم الهاتف </label>

              <input type="text"   formControlName="phone"  placeholder="رقم الهاتف" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>كلمة المرور </label>

              <input type="text" formControlName="password" placeholder="كلمة المرور" class="form-control">
            </div>
            <div class="col-md-6" *ngIf="!isAdmin">
              <label>الدور الوظيفي </label>

              <select class="form-control" formControlName="type" >
                <option value="" disabled selected>الدور الوظيفي</option>
                <option value="2">مسؤول حركة</option>
                <option value="3">محرر أخبار</option>
<!--                <option value="3">3</option>-->
              </select>
            </div>

          </div>

        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button"  style="width:280px"  (click)="editMode?edit():add()" [disabled]="!data.valid" data-dismiss="modal"  class="btn radius-16  background-blue-g pr-5 pl-5" >
                {{editMode?"تعديل":"إضافة"}}


              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="uniModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title"> تعديل بيانات الجامعة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <p>معلومات الجامعة</p>
        <form [formGroup]="uniData"  >
          <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12  text-center">
            <img [src]="profileImg" (click)="openFile()"  alt="User Pic"  id="profile-image" class=" img-circle img-responsive">

            <input (change)="changeImage($event)" accept="image/*" type="file" id="file"  style="display:none"/>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>اسم الجامعة </label>

              <input type="text"  formControlName="ar_name" placeholder="اسم الجامعة" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>البريد الإلكتروني </label>

              <input type="text" formControlName="email" placeholder="البريد الإلكتروني" class="form-control">
            </div>
            <div class="col-md-6">
              <label>رقم الهاتف  </label>

              <input type="text"   formControlName="phone"  placeholder="رقم الهاتف" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>الموفع الإلكتروني  </label>

              <input type="text" formControlName="website" placeholder="الموفع الإلكتروني" class="form-control">
            </div>

            <div class="col-md-6">
              <label>العنوان  </label>

              <input type="text" formControlName="address" placeholder="العنوان" class="form-control">
            </div>


          </div>

        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button"  style="width:280px"  (click)="editUniversity()" [disabled]="!uniData.valid" data-dismiss="modal"  class="btn radius-16  background-blue-g pr-5 pl-5" >
                تعديل


              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content modal-raduis    radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف السائق</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class=" container text-center">
            <p class="text-black ">
              هل ترغب بالفعل بمنع ({{rowSelected['name']}} ) من الوصول لهذه المنصة ؟
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5"  data-dismiss="modal" (click)="removeAdmin(rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>


<!--<div class="row">-->
<!--  <div class="col-md-12 text-center ">-->
<!--      <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 mb-2 ">-->
<!--        <img   alt="User Pic" src="assets/images/profile-square.jpg" id="profile-image" class="radius-50 img-circle img-responsive">-->


<!--      </div>-->
<!--      <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 text-left" >-->
<!--        <div class="container" >-->
<!--          <span>الاسم:</span>-->
<!--          <p>{{name}}</p>-->


<!--        </div>-->

<!--      </div>-->
<!--    <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 text-left" >-->
<!--      <div class="container" >-->
<!--        <span>نوع الحساب:</span>-->
<!--        <p>{{typeText}}</p>-->


<!--      </div>-->

<!--    </div>-->
<!--    <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 text-left" >-->
<!--      <div class="container" >-->
<!--        <span>الجامعة :</span>-->
<!--        <p>{{uni}}</p>-->


<!--      </div>-->

<!--    </div>-->
<!--    </div>-->

<!--  </div>-->

